import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router'
import { TRPCProvider } from './providers/trpc'
import { AuthProvider } from './hooks/useAuth'
import App from './App'
import SWRegister from './components/SWRegister'
import './index.css'

// ── Bootstrap ──
const rootEl = document.getElementById('root')
if (!rootEl) throw new Error('Root element not found')

// For prerendered HTML: use hydrateRoot so React attaches to existing DOM
// instead of replacing it. Only applies to homepage (/) — other routes
// receive the same HTML shell but must use createRoot to avoid hydration
// mismatch against the homepage prerender.
const isHomepage = window.location.pathname === '/' || window.location.pathname === ''
const hasPrerenderedContent = rootEl.childNodes.length > 0 && rootEl.innerHTML.trim().length > 20
const useHydrate = isHomepage && hasPrerenderedContent

const app = (
  <BrowserRouter>
    <TRPCProvider>
      <AuthProvider>
        <SWRegister />
        <App />
      </AuthProvider>
    </TRPCProvider>
  </BrowserRouter>
)

if (useHydrate) {
  // Defer hydration to allow LCP to fire on prerendered content.
  // The prerendered HTML is fully visible and styled; hydration adds
  // interactivity (event listeners, state, effects).
  setTimeout(() => {
    ReactDOM.hydrateRoot(rootEl, app)
  }, 5000) // 5s delay — ensures LCP fires before hydration
} else {
  ReactDOM.createRoot(rootEl).render(app)
}
